import clsx from 'clsx';
import { ReactNode } from 'react';
import { UiColor } from '../types/colors';

type TagType = 'light' | 'fill' | 'dot';

interface NTagProps {
  children: ReactNode;
  className?: string;
  dotClassName?: string;
  type?: TagType;
  color?: UiColor;
  loading?: boolean;
}

const colorMap: Record<UiColor, Record<TagType, string>> = {
  primary: {
    light: 'bg-primary/50 text-slate-900 border border-primary/30',
    fill: 'bg-primary text-black',
    dot: 'bg-primary/20 text-slate-900'
  },
  secondary: {
    light: 'bg-slate-200 text-slate-900 border border-slate-300',
    fill: 'bg-slate-900 text-white',
    dot: 'bg-slate-200 text-slate-900'
  },
  tertiary: {
    light: 'bg-slate-100 text-slate-600 border border-slate-200',
    fill: 'bg-slate-200 text-slate-600',
    dot: 'bg-slate-200 text-slate-600'
  },
  info: {
    light: 'bg-info-100 text-info-700 border border-info-200',
    fill: 'bg-info-600 text-white',
    dot: 'bg-info-100 text-info-700'
  },
  success: {
    light: 'bg-success-100 text-success-700 border border-success-200',
    fill: 'bg-success-700 text-white',
    dot: 'text-success-700 bg-success-100'
  },
  error: {
    light: 'bg-error-100 text-error-700 border border-error-200',
    fill: 'bg-error-600 text-white',
    dot: 'text-error-600 bg-error-100'
  }
};


const dotColors = {
  primary: 'bg-primary',
  secondary: 'bg-slate-900',
  tertiary: 'bg-slate-500',
  info: 'bg-info-700',
  success: 'bg-green-700',
  error: 'bg-red-600'
};

export const NTag = ({
                       children,
                       className,
                       type = 'fill',
                       color = 'primary',
                       loading = false,
                       dotClassName
                     }: NTagProps) => {
  return (
    <span
      className={clsx(
        'inline-flex items-center text-xs font-medium w-fit h-fit px-2 py-0.5 rounded-full',
        colorMap[color][type],
        loading && 'bg-loading',
        className
      )}
    >
      {type === 'dot' && (
        <span
          className={clsx(
            'w-2 h-2 rounded-full mr-1',
            dotColors[color],
            dotClassName
          )}
        />
      )}
      {children}
    </span>
  );
};
